export default __webpack_public_path__ + "static/media/pub_grillades.d600121e.jpg";